/**
 * User Analytics API
 * მომხმარებლის ანალიტიკის API
 */

import { get } from '@aiia/portal-core';

export type StatisticsPeriod = 'TODAY' | 'WEEK' | 'MONTH' | 'QUARTER' | 'YEAR';

export interface TimeSeriesPoint {
  date: string;
  value: number;
}

export interface AnalyticsOverviewResponse {
  totalConversations: number;
  activeConversations: number;
  conversationsToday: number;
  totalMessages: number;
  messagesToday: number;
  totalTokens: number;
  activeWidgets: number;
  totalWidgets: number;
  activeApiKeys: number;
  totalApiKeys: number;
  totalDataFiles: number;
  processedDataFiles: number;
}

export interface AnalyticsTrafficResponse {
  totalConversations: number;
  activeConversations: number;
  conversationsToday: number;
  totalMessages: number;
  messagesToday: number;
  totalTokens: number;
  tokensToday: number;
  conversationsByChannel: Record<string, number>;
  conversationTrend: TimeSeriesPoint[];
  messageTrend: TimeSeriesPoint[];
  tokenTrend: TimeSeriesPoint[];
}

export const getAnalyticsOverview = () =>
  get<AnalyticsOverviewResponse>('/analytics/overview');

export const getAnalyticsTraffic = (period: StatisticsPeriod = 'MONTH') =>
  get<AnalyticsTrafficResponse>(`/analytics/traffic?period=${period}`);
